import { CustomActionMap } from '@lib/data-dog-rum/custom-action-map';

import { EventTypes } from './azure-pub-sub.constants';

export interface FsAzurePubSubEvent<T = any> {
  connectionId: string;
  message: T;
  group?: string;
}

export type AzureAnalyticsActionMap = CustomActionMap & {
  azure_pubsub_client_connection_success: {
    connectionId: string;
    organizationId: string;
  };
  azure_pubsub_client_connection_failure: {
    error: any;
    organizationId: string;
  };
  azure_pubsub_client_disconnect_success: {
    connectionId: string;
    organizationId: string;
  };
  azure_pubsub_client_disconnect_failure: {
    error: any;
    organizationId: string;
  };
  azure_pubsub_client_not_initialized: {
    error?: any;
    organizationId: string;
  };
  azure_pubsub_heartbeat_success: {
    error?: any;
    organizationId: string;
  };
  azure_pubsub_heartbeat_failure: {
    error: any;
    organizationId: string;
  };
  azure_pubsub_send_event_success: {
    channelName: string[];
    connectionId: string;
    event: EventTypes;
    organizationId: string;
  };
  azure_pubsub_send_event_failure: {
    channelName: string[];
    connectionId: string;
    event: EventTypes;
    error: any;
    organizationId: string;
  };
  azure_pubsub_join_group_success: {
    groupName: string;
    connectionId: string;
    organizationId: string;
  };
  azure_pubsub_join_group_failure: {
    groupName: string;
    connectionId: string;
    error: any;
    organizationId: string;
  };
  azure_pubsub_leave_group_success: {
    groupName: string;
    connectionId: string;
    organizationId: string;
  };
  azure_pubsub_leave_group_failure: {
    groupName: string;
    connectionId: string;
    error: any;
    organizationId: string;
  };
  azure_pubsub_message_metrics: {
    messageCount: number;
    duration: number;
    connectionId: string;
    organizationId: string;
    messages: Array<{
      id: string;
      receivedTimestamp: number;
      group: string;
    }>;
  };
};
